/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/QaUndoBar.tsx
 * FILE_ID: JOBHUB-QA-UNDO-BAR-001
 * PURPOSE: Offer Undo for the move that just happened.
 * WHY: A move is the user teaching the tree something the quote never said.
 *      Getting it wrong has to cost one click, or they will not risk the first
 *      one.
 * LANDMINE: Normal flow, not a floating toast (rule 06). It sits above the list
 *      it describes and reflows it; nothing here is absolute, fixed or
 *      z-indexed, so it can never cover the rows the user is checking.
 */
import { Loader2, Undo2 } from 'lucide-react'

export function QaUndoBar({
  message,
  busy = false,
  onUndo,
  onDismiss,
}: {
  message: string
  busy?: boolean
  onUndo: () => void
  onDismiss: () => void
}) {
  return (
    <div
      className="mb-1 flex flex-wrap items-center gap-2 rounded-lg border border-border bg-muted/40 px-2 py-1.5"
      data-testid="qa-undo-bar"
    >
      <span className="min-w-0 flex-1 truncate text-[11px] text-muted-foreground">{message}</span>
      <button
        type="button"
        disabled={busy}
        onClick={onUndo}
        data-testid="qa-undo"
        className="inline-flex shrink-0 items-center gap-1 rounded-md border border-border bg-background px-2 py-1 text-[11px] font-medium text-foreground hover:bg-accent disabled:opacity-50"
      >
        {busy ? (
          <Loader2 className="h-3 w-3 animate-spin" aria-hidden />
        ) : (
          <Undo2 className="h-3 w-3" aria-hidden />
        )}
        Undo
      </button>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="shrink-0 rounded-md px-2 py-1 text-[11px] text-muted-foreground hover:text-foreground"
      >
        Dismiss
      </button>
    </div>
  )
}
